<template>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="grid-stack-item">
            <div class="header">
                <h1>{{ $t('Create Email Template') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="emailTemplateForm" :rules="rules" ref="emailTemplateForm">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-form-item :label="$t('Title')" prop="title">
                                    <el-input v-model="emailTemplateForm.title"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Subject')" prop="subject">
                                    <el-input v-model="emailTemplateForm.subject"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Mail Content')" prop="message">
                                    <el-input type="textarea" :rows="10" placeholder="Please input" v-model="emailTemplateForm.message">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Status')">
                                    <el-switch v-model="emailTemplateForm.status" active-color="#13ce66" inactive-color="#ff4949"
                                        active-value="active" inactive-value="inactive">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('emailTemplateForm')">{{ $t('Create')
                                        }}</el-button>
                                    <router-link tag="el-button" to="/email-templates" class="el-button--cancel">{{ $t('Cancel')
                                        }}</router-link>
                                    <el-button type="info" @click="dialogPreviewVisible = true" v-if="emailTemplateForm.subject && emailTemplateForm.message">{{ $t('Preview') }}</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
        <el-dialog  :title="emailTemplateForm.subject" :visible.sync="dialogPreviewVisible">
            <div v-html="emailTemplateForm.message"></div>
        </el-dialog>
    </el-row>
</template>

<script>
    export default {
        data() {
            return {
                emailTemplateForm: {
                    status: 'active',
                },
                dialogPreviewVisible: false,
                labelPosition: "top",
                rules: {
                    title: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    subject: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    message: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }]
                }
            };
        },
        mounted() {},
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$parent.fullscreenLoading = true;
                        request({
                                url: "email-templates",
                                method: "post",
                                data: this.emailTemplateForm
                            })
                            .then(response => {
                                this.$parent.fullscreenLoading = false;
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                this.$router.push("/email-templates");
                            })
                            .catch(error => {
                                this.$parent.fullscreenLoading = false;
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/EmailTemplates/CreateEmailTemplate.vue